export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Est-ce un produit physique ?',
    answer: 'Non. ATLAS VISUEL ECG PRO™ est un système 100 % numérique au format PDF, lisible sur ordinateur, tablette ou téléphone.',
  },
  {
    question: 'À qui s’adresse-t-il ?',
    answer:
      'Aux infirmiers et infirmières (services, urgences, cardiologie, soins critiques), aux étudiants en soins infirmiers (IFSI), aux étudiants en médecine et externes, et à tous les soignants qui surveillent des patients sous scope.',
  },
  {
    question: 'Faut-il déjà savoir lire un ECG ?',
    answer:
      'Non. Le module 1 reprend les fondamentaux (conduction, 12 dérivations, ondes, papier millimétré) et le module 2 installe une méthode pas à pas : FRÉQUENCE › RYTHME › AXE › INTERVALLES › ST-T.',
  },
  {
    question: 'Est-ce un cours théorique ?',
    answer:
      'Non. C’est une bibliothèque visuelle prête à consulter : tracés annotés, planches normal / anormal, fiches pratiques, arbres de décision et cas pédagogiques corrigés.',
  },
  {
    question: 'Vais-je apprendre à poser un diagnostic ?',
    answer:
      'Non. L’interprétation diagnostique et la décision thérapeutique relèvent du médecin. L’atlas vous apprend à lire un tracé avec méthode, à reconnaître une anomalie, à transmettre et à alerter selon les protocoles de l’établissement.',
  },
  {
    question: 'Des doses de médicaments sont-elles indiquées ?',
    answer:
      'Non. Aucune dose ni posologie : tout traitement est mentionné « selon la prescription médicale et les protocoles de l’établissement ».',
  },
  {
    question: 'Les tracés sont-ils des ECG de patients ?',
    answer:
      'Non. Les tracés sont des illustrations pédagogiques et les cas sont des cas pédagogiques fictifs.',
  },
  {
    question: 'Que contiennent les 5 bonus ?',
    answer:
      'Guide de pose des électrodes et des 12 dérivations, atlas des rythmes en un coup d’œil, fiches mémo de poche, ECG et médicaments (QT, antiarythmiques, surveillance infirmière) et cahier d’entraînement de 100 tracés.',
  },
  {
    question: 'Est-ce une certification ou une formation qualifiante ?',
    answer:
      'Non. C’est un support pédagogique. Il ne remplace ni la formation, ni l’avis médical, ni les protocoles de l’établissement.',
  },
  {
    question: 'Comment vais-je recevoir le produit ?',
    answer: 'Vous recevez l’accès numérique immédiatement après l’achat, par e-mail.',
  },
]
